<div class="container container--stats position-relative">
  <div class="row">
    <div class="col-6 stats-card-col col-md-3 mb-3">
      <div
        class="stats-card overflow-hidden position-relative"
        [routerLink]="['/', routes.home, routes.datasets, routes.all]"
      >
        <img
          width="100%"
          height="100%"
          fetchpriority="high"
          loading="eager"
          src="images/datasets.png"
          alt="Datasets"
          class="position-absolute stats-card--watermark"
        />
        <div class="stats-card__content position-relative w-100 h-100">
          <h4>
            {{ addPlusIfGreater(stats?.datasets, statThreshold.datasets) }}
          </h4>
          <p class="mb-0">Datasets</p>
        </div>
        <div class="arrow-icon-stats">
          <img
            width="36"
            height="36"
            fetchpriority="low"
            src="images/right-arrow-cards.svg"
            alt="View"
          />
        </div>
      </div>
    </div>
    <div class="col-6 stats-card-col col-md-3 mb-3">
      <div
        class="stats-card overflow-hidden position-relative"
        [routerLink]="['/', routes.home, routes.models, routes.all]"
      >
        <img
          width="100%"
          height="100%"
          fetchpriority="high"
          src="images/models.png"
          alt="Models"
          class="position-absolute stats-card--watermark"
        />
        <div class="stats-card__content position-relative w-100 h-100">
          <h4>{{ addPlusIfGreater(stats?.models, statThreshold.models) }}</h4>
          <p class="mb-0">Models</p>
        </div>
        <div class="arrow-icon-stats">
          <img
            width="36"
            height="36"
            fetchpriority="low"
            src="images/right-arrow-cards.svg"
            alt="View"
          />
        </div>
      </div>
    </div>
    <div class="col-6 stats-card-col col-md-3">
      <div
        class="stats-card overflow-hidden position-relative"
        (click)="scrollToExploreBySector()"
      >
        <img
          width="100%"
          height="100%"
          fetchpriority="high"
          src="images/sectors.png"
          alt="Sectors"
          class="position-absolute stats-card--watermark"
        />
        <div class="stats-card__content position-relative w-100 h-100">
          <h4>
            {{ addPlusIfGreater(stats?.sectors, statThreshold.sectors) }}
          </h4>
          <p class="mb-0">Sectors</p>
        </div>
        <div class="arrow-icon-stats">
          <img
            width="36"
            height="36"
            fetchpriority="low"
            src="images/right-arrow-cards.svg"
            alt="View"
          />
        </div>
      </div>
    </div>
    <div class="col-6 stats-card-col col-md-3">
      <div
        class="stats-card overflow-hidden position-relative"
        [routerLink]="['/', routes.home, routes.organization, routes.all]"
      >
        <img
          width="100%"
          height="100%"
          fetchpriority="high"
          src="images/ministries.png"
          alt="Ministries"
          class="position-absolute stats-card--watermark"
        />
        <div class="stats-card__content position-relative w-100 h-100">
          <h4>
            {{ stats?.organizations }}
          </h4>
          <p class="mb-0">Organizations</p>
        </div>
        <div class="arrow-icon-stats">
          <img
            width="36"
            height="36"
            fetchpriority="low"
            src="images/right-arrow-cards.svg"
            alt="View"
          />
        </div>
      </div>
    </div>
  </div>
</div>
